import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-coupon-02',
  standalone: true,
  templateUrl: '../../assets/coupon-02.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCoupon02Icon {}
